import { Droppable, Draggable } from "@hello-pangea/dnd";
import CustomSVG from "../../components/UniversalComponents/CustomSVG";
import ToggleSwitch from "../UniversalComponents/SwitchButton";

const InputDrawer = ({
  inputs,
  setSectionNameModal,
  inputPermissionList,
  sectionList,
  setSectionsList,
  linkedSections,
  setLinkedSections,
  handleUpdateTemplatePermission = () => {},
  isDeployed,
  is_tag_exist,
}) => {
  const handleToggleSwitch = ({ data, result }) => {
    handleUpdateTemplatePermission(data, result);
  };

  return (
    <div className="flex flex-col  py-1 bg-primary-hover   h-full">
      {/* Header */}
      <h2 className="px-4 py-2 mb-1  text-md text-[#131313CC] flex items-center text-base justify-start ">Add Field</h2>

      {/* Inputs drawer */}
      <Droppable droppableId="INPUT_DRAWER" isDropDisabled={false} type="INPUT">
        {(provided) => (
          <div className="grid grid-cols-2 gap-3 px-4" ref={provided.innerRef} {...provided.droppableProps}>
            {inputs
              ?.filter(
                (i) => (is_tag_exist ? i?.inputType !== "tags" : true) // render all when is_tag_exist is false
              )
              ?.map((input, index) => (
                <Draggable
                  key={input.inputType}
                  draggableId={input.inputType}
                  index={index}
                  isDragDisabled={isDeployed}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="flex items-center justify-start gap-2 border rounded-md px-3 py-2 text-sm font-normal cursor-pointer transition group hover:border-primary hover:bg-primary-hover bg-white border-[#E3E3E3] hover:text-primary text-[#131313CC]/80"
                    >
                      {input?.svg && (
                        <CustomSVG
                          svg={input?.svg}
                          width="w-5"
                          height="h-5"
                          color="fill-[#131313CC] group-hover:fill-primary"
                          className="transition group-hover:primary text-[#131313CC]"
                        />
                      )}
                      <span className="group-hover:text-primary transition text-sm text-[#131313CC]">
                        {input.inputName}
                      </span>
                    </div>
                  )}
                </Draggable>
              ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      {/* Add section button */}
      <div className="flex items-center justify-center w-full px-4">
        <button
          onClick={() => setSectionNameModal(true)}
          disabled={isDeployed}
          className="flex w-full justify-center  px-3 py-2 items-center gap-2 mt-4 cursor-pointer group hover:text-primary text-primary hover:bg-primary-hover bg-white border border-[#E3E3E3] hover:border-primary rounded-md"
        >
          + Add Section
        </button>
      </div>

      {/* Scrollable sections list */}
      <div className="flex flex-col mt-4 min-h-0 flex-1">
        <p className="font-500 mb-2 text-md text-gray-700 px-4">Section</p>
        <div className="flex flex-col gap-3 min-h-0 px-4 flex-1 overflow-y-auto thinscrollbar">
          {sectionList
            ?.filter((permission) => permission?.is_locked === 1 && permission?.section_name === "Funnel Information")
            ?.map((section, index) => {
              const isLinked = linkedSections?.some((check) => check?.id === section?.id);

              return (
                <div key={index} className="flex items-center justify-between px-3 py-2 bg-primary-active rounded-lg">
                  <p className="text-[#666666] text-sm">{section?.section_name}</p>
                  <ToggleSwitch
                    checked={isLinked}
                    onChange={() => handleToggleSwitch({ data: section, result: isLinked })}
                    showText={false}
                    fillColor="var(--color-primary)"
                    disabled={isDeployed}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default InputDrawer;
